import { ReactNode } from 'react'

interface SectionCardProps {
  title: string
  subtitle?: string
  loading?: boolean
  error?: string | null
  children: ReactNode
  className?: string
  /** When true, uses flexible height instead of fixed h-64 (for dashboard widget embedding) */
  embedded?: boolean
}

export default function SectionCard({ title, subtitle, loading, error, children, className = '', embedded = false }: SectionCardProps) {
  const placeholderHeight = embedded ? 'h-full min-h-[8rem]' : 'h-64'
  return (
    <div className={`${embedded ? '' : 'bg-white rounded-xl shadow'} p-4 ${embedded ? 'h-full flex flex-col' : ''} ${className}`}>
      <div className="mb-3 shrink-0">
        <h3 className="text-sm font-medium text-gray-900">{title}</h3>
        {subtitle && <p className="text-xs text-gray-500 mt-0.5">{subtitle}</p>}
      </div>
      {loading ? (
        <div className={`${placeholderHeight} flex items-center justify-center`}>
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500" />
        </div>
      ) : error ? (
        <div className={`${placeholderHeight} flex items-center justify-center text-sm text-red-500`}>
          {error}
        </div>
      ) : (
        <div className={embedded ? 'flex-1 min-h-0' : ''}>
          {children}
        </div>
      )}
    </div>
  )
}
